import { create } from "zustand";

export type ToastTone = "info" | "success" | "error";

export interface ToastEntry {
  id: number;
  message: string;
  tone: ToastTone;
}

interface ToastState {
  toasts: ToastEntry[];
  push: (message: string, tone?: ToastTone) => number;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, tone = "info") => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, message, tone }] }));
    return id;
  },
  dismiss: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));

export function showToast(message: string, tone: ToastTone = "info"): void {
  useToastStore.getState().push(message, tone);
}
